import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartPresetId } from '@cli-types/preset-engine/presets.js'
import { normalizeInstalledIds } from '@core-engine/installable/protocol/normalize-installed-ids.js'
import { isPresetId } from '@next-adapter/preset-registry.js'

export function normalizeInstalledPresets(
  config: ResolvedBetterstartConfig
): BetterstartPresetId[] {
  return normalizeInstalledIds(config.presets.installed, isPresetId)
}
